import { observer } from "mobx-react-lite";
import AppConfig from "core/app-config";
import { AnalyticsHelper } from "core/lib/analytics";

type SearchInputProps = {
  hasFilter: boolean;
  filterCities: (value: string) => void;
  clearFilter: () => void;
  useMyLocation: () => void;
  onClick: () => void;
}

const SearchInput = observer<SearchInputProps>((props) => {
  const { hasFilter, filterCities, clearFilter, useMyLocation, onClick } = props;

  const _filterCities = (e: any) => {
    const needle = e.target.value.toLowerCase();

    filterCities(needle);

    AnalyticsHelper.handleSearch(needle);
  }

  return <form>
    <div className="search-input">
      <input type="text" placeholder={AppConfig.enterYourCity} onClick={onClick} onKeyUp={_filterCities} />
      {hasFilter
        ? <i className="icon-Close_M" onClick={clearFilter} />
        : <i className="icon-search" />}
    </div>

    <div className="search-actions">
      <button type="button" className="current-location" onClick={useMyLocation}>
        <i className="icon-find-a-dealer icon" /> <span>{AppConfig.useMyCurrentLocation}</span>
      </button>

      {AppConfig.callMeLink && <span className="call-me">
          <i className="icon-contact icon" />
          Still not sure?&nbsp;
          <a href={AppConfig.callMeLink}>Call Me</a> for new installations only
      </span>}
    </div>
  </form>;
});

export default SearchInput
